import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  const currency = useState('currency', () => ({
    enable: false,
    settings: null
  }))


  nuxtApp.hooks.hook('app:created', () => {
    const initialCurrency = nuxtApp.ssrContext?.event.context.currency
    if (initialCurrency) {
      currency.value = initialCurrency
    }
  })

  return {
    provide: {
      currency
    }
  }
})